import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';
import useGetUserState from '../hooks/useGetUserState';

const Context = createContext({
  userStateData: {},
  isFetching: true,
});

export default Context;

export const UserStateContextProvider = ({children}) => {
  const {data, isLoading} = useGetUserState();
  const shippingAddressSet = data?.user?.shippingAddress?.isSet;
  const [
    hasShippingAddressOptimistic,
    setHasShippingAddressOptimistic,
  ] = useState(shippingAddressSet);

  return (
    <Context.Provider
      value={{
        userStateData: data?.user || {},
        isFetching: isLoading,
        hasShippingAddressOptimistic,
        setHasShippingAddressOptimistic,
      }}>
      {children}
    </Context.Provider>
  );
};

UserStateContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
